import { Component, OnInit ,Input} from '@angular/core';

import { BuyService } from '../../../../services/buyservice'
@Component({
  selector: 'app-orderlist',
  templateUrl: './orderlist.component.html',
  styleUrls: ['./orderlist.component.css']
})
export class OrderlistComponent implements OnInit {

  @Input('data') meals: string[] = [];
  page: number = 1;
  ItemOrder;
  constructor(private buy: BuyService) { }

  ngOnInit() {
    let dataItem = this.buy.getOrder()
    dataItem.subscribe((snap) => {
      this.ItemOrder = snap
    })
  }



}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/ordered/orderlist/orderlist.component.ts